import { useState } from 'react';
import { User } from '@supabase/supabase-js';
import { TicketForm } from './TicketForm';
import { TicketList } from './TicketList';
import { Card } from '@/components/ui/card';
import { Mail } from 'lucide-react';

interface HelpTabProps {
  user: User;
}

export function HelpTab({ user }: HelpTabProps) {
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <div className="space-y-6">
      <TicketForm user={user} onTicketCreated={() => setRefreshKey((k) => k + 1)} />
      <TicketList user={user} refreshKey={refreshKey} />

      <Card className="rounded-none border-0 border-t border-[var(--sn-border)] bg-transparent px-0 py-6 shadow-none">
        <div className="flex items-start gap-3">
          <Mail className="w-5 h-5 text-primary mt-0.5 shrink-0" />
          <div className="text-sm">
            <p className="font-medium text-foreground mb-1">Email support</p>
            <p className="text-muted-foreground">
              You can also write to us directly at{' '}
              <a href="mailto:info@shikshannivesh.com" className="text-primary hover:underline">
                info@shikshannivesh.com
              </a>
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
}
